// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__3xYyY {\n    padding: 50px;\n}\n\n.centeredContainer__2ZOgB {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.logo__zF6Z6 {\n    width: 220px;\n}\n\n.logo__zF6Z6 svg {\n    height: inherit;\n    width: inherit;\n}\n\n.title__2EnkT {\n    text-align: center;\n    font-size: xx-large;\n}", ""]);
// Exports
exports.locals = {
	"container": "container__3xYyY",
	"centeredContainer": "centeredContainer__2ZOgB",
	"logo": "logo__zF6Z6",
	"title": "title__2EnkT"
};
module.exports = exports;
